import React from 'react';
import { withStyles, Button, Typography, TextField, Divider } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CycleTasks from './CycleTasks';

const styles = theme => ({
    addButton: {
        marginTop: 10,
        width: 40,
        height: 20
    }
});

class ProcessButtons extends React.Component {
    state = {
        arrayForMap: {}
    };

    static getDerivedStateFromProps(props, state) {
        if (!props.arrayForMap) {
            return {
                arrayForMap: {}
            }
        } else if (Object.keys(props.arrayForMap).length !== Object.keys(state.arrayForMap).length) {
            return {
                arrayForMap: props.arrayForMap
            }
        } else {
            return state;
        }
    }

    render() {
        const { onAddProperty, name, classes, arrayName, onTaskClick, arrayForMap, onTaskReorder, onTaskRemove, dueDate, onDueDateChange, subTaskAssigned, cycleId, onTaskDueDateChange, orderBy, onActiveTaskToggle } = this.props;
        return (
            <div className="cycleBox">
                <Typography variant="title" gutterBottom>{name}</Typography>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end'
                }}>
                    <Typography style={{ marginRight: 10, color: "grey" }}>fällig am:</Typography>
                <TextField
                    inputProps={{ style: { color: "grey" } }}
                    id={"dueDate" + name}
                    type="date"
                    value={dueDate}
                    onChange={(e) => onDueDateChange(e.target.value)}
                />
                </div>
                <Divider />
                <Button
                    className={classes.addButton}
                    variant="fab"
                    color="primary"
                    aria-label="Add"
                    onClick={() => onAddProperty(arrayName)}
                >
                    <AddIcon />
                </Button>
                <CycleTasks
                    cycleId={cycleId}
                    tasks={arrayForMap}
                    subTaskAssigned={subTaskAssigned}
                    phase={arrayName}
                    onTaskReorder={onTaskReorder}
                    onTaskClick={onTaskClick}
                    onTaskRemove={onTaskRemove}
                    onTaskDueDateChange={onTaskDueDateChange}
                    orderBy={orderBy}
                    onActiveTaskToggle={onActiveTaskToggle}
                />
                {/*
                TODO: renderovati popup na +
                */}
            </div>
        );
    }
}

export default withStyles(styles)(ProcessButtons);



// WEBPACK FOOTER //
// ./src/components/common/ProcessButtons_v2.js